(function () {
  var WEIGHT_CAP = 20;

  function cartBase() {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return base.charAt(base.length - 1) === '/' ? base : base + '/';
  }

  function formatMoney(cents) {
    return '£' + (Number(cents) / 100).toFixed(2);
  }

  function readCart(root) {
    return fetch(cartBase() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { renderCart(root, cart); return cart; });
  }

  function deliveryMessage(cents, threshold) {
    if (!cents) return 'Spend ' + formatMoney(threshold) + ' for FREE Delivery';
    var left = Math.max(0, threshold - cents);
    if (left === 0) return 'You\u2019ve unlocked FREE Delivery!';
    return 'Only ' + formatMoney(left) + ' more for FREE Delivery';
  }

  function renderCart(root, cart) {
    var threshold = Number(root.getAttribute('data-free-pence')) || 3000;
    var total = cart.total_price || 0;
    root.querySelectorAll('[data-cart-count]').forEach(function (node) { node.textContent = cart.item_count; });
    root.querySelectorAll('[data-cart-total]').forEach(function (node) { node.textContent = formatMoney(total); });
    var message = deliveryMessage(total, threshold);
    var width = total <= 0 ? 0 : Math.min(100, (total / threshold) * 100);
    root.querySelectorAll('[data-cart-msg]').forEach(function (node) { node.textContent = message; });
    root.querySelectorAll('[data-cart-bar]').forEach(function (node) { node.style.width = width + '%'; });
  }

  function refreshDrawer() {
    var current = document.querySelector('.js-popup-cart-ajax');
    if (!current) return Promise.resolve();
    return fetch(cartBase() + 'cart?view=popup', { headers: { Accept: 'text/html' } })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('.js-popup-cart-ajax');
        if (next) current.innerHTML = next.innerHTML;
      })
      .catch(function () {});
  }

  function lowWidth(qty) {
    return Math.max(8, (WEIGHT_CAP - Number(qty)) * 5);
  }

  function selectWeight(button) {
    var card = button.closest('.card');
    card.querySelectorAll('.weight').forEach(function (item) {
      item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
    });
    var price = card.querySelector('.card__price');
    if (price) price.textContent = formatMoney(button.getAttribute('data-price'));
    var low = card.querySelector('[data-low]');
    if (!low) return;
    var left = button.getAttribute('data-left');
    if (left) {
      low.hidden = false;
      var num = low.querySelector('[data-left-num]');
      var fill = low.querySelector('[data-low-fill]');
      if (num) num.textContent = left;
      if (fill) fill.style.width = lowWidth(left) + '%';
    } else {
      low.hidden = true;
    }
  }

  function addToCart(root, button) {
    var card = button.closest('.card');
    var selected = card.querySelector('.weight[aria-pressed="true"]');
    if (!selected || selected.disabled || button.disabled) return;
    var label = button.getAttribute('data-label') || button.innerHTML;
    button.disabled = true;
    fetch(cartBase() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(selected.getAttribute('data-id')), quantity: 1 })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (error) {
          window.alert((error && error.description) || 'Could not add that to your bag.');
          button.disabled = false;
        });
      }
      return fetch(cartBase() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (cartResponse) { return cartResponse.json(); })
        .then(function (cart) {
          renderCart(root, cart);
          return refreshDrawer();
        })
        .then(function () {
          button.classList.add('is-added');
          button.textContent = 'Added';
          window.setTimeout(function () {
            button.classList.remove('is-added');
            button.innerHTML = label;
            button.disabled = false;
          }, 1200);
        });
    }).catch(function () {
      window.alert('Could not add that to your bag.');
      button.disabled = false;
    });
  }

  function tick(root) {
    var target = new Date(root.getAttribute('data-halloween') || '2026-10-31T00:00:00Z').getTime();
    var remaining = Math.max(0, target - Date.now());
    var days = Math.floor(remaining / 86400000);
    remaining -= days * 86400000;
    var hours = Math.floor(remaining / 3600000);
    remaining -= hours * 3600000;
    var minutes = Math.floor(remaining / 60000);
    remaining -= minutes * 60000;
    var seconds = Math.floor(remaining / 1000);
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var clock = root.querySelector('[data-clock]');
    if (clock) {
      clock.querySelector('[data-d]').textContent = pad(days);
      clock.querySelector('[data-h]').textContent = pad(hours);
      clock.querySelector('[data-m]').textContent = pad(minutes);
      clock.querySelector('[data-s]').textContent = pad(seconds);
    }
    root.querySelectorAll('[data-timer-short]').forEach(function (node) {
      node.textContent = days + 'd ' + hours + 'h ' + minutes + 'm';
    });
  }

  function heroCopy(root) {
    var narrow = window.matchMedia('(max-width: 1099px)').matches;
    var longCopy = root.querySelector('.hero__text .long');
    var shortCopy = root.querySelector('.hero__text .short');
    if (longCopy) longCopy.hidden = narrow;
    if (shortCopy) shortCopy.hidden = !narrow;
  }

  function boot(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    root._readCart = function () { readCart(root); };
    root.querySelectorAll('.add').forEach(function (button) {
      button.setAttribute('data-label', button.innerHTML);
    });
    root.addEventListener('click', function (event) {
      var weight = event.target.closest('.weight');
      if (weight && root.contains(weight) && !weight.disabled) {
        selectWeight(weight);
        return;
      }
      var add = event.target.closest('.add');
      if (add && root.contains(add)) addToCart(root, add);
    });
    var bag = root.querySelector('[data-cart-open]');
    if (bag) {
      bag.addEventListener('click', function () {
        if (!document.querySelector('[data-js-popup-name="cart"]')) {
          window.location.href = cartBase() + 'cart';
        }
      });
    }
    var ugc = root.querySelector('.ugc__grid');
    var ugcPrev = root.querySelector('.ugc__arrow--prev');
    var ugcNext = root.querySelector('.ugc__arrow--next');
    if (ugc && ugcPrev && ugcNext) {
      var ugcStep = function () {
        var item = ugc.querySelector('.ugc__item');
        var gap = parseFloat(getComputedStyle(ugc).columnGap) || 16;
        return (item ? item.getBoundingClientRect().width : 230) + gap;
      };
      var ugcArrows = function () {
        var max = ugc.scrollWidth - ugc.clientWidth - 2;
        ugcPrev.disabled = ugc.scrollLeft <= 2;
        ugcNext.disabled = ugc.scrollLeft >= max;
      };
      ugcPrev.addEventListener('click', function () {
        ugc.scrollBy({ left: -ugcStep(), behavior: 'smooth' });
      });
      ugcNext.addEventListener('click', function () {
        ugc.scrollBy({ left: ugcStep(), behavior: 'smooth' });
      });
      ugc.addEventListener('scroll', ugcArrows, { passive: true });
      ugcArrows();
    }
    lazyVideos(root);
    initTabs(root);
    tick(root);
    root._timer = window.setInterval(function () { tick(root); }, 1000);
    heroCopy(root);
    var query = window.matchMedia('(max-width: 1099px)');
    if (query.addEventListener) query.addEventListener('change', function () { heroCopy(root); });
    else if (query.addListener) query.addListener(function () { heroCopy(root); });
    readCart(root).catch(function () {});
  }

  function initTabs(root) {
    var tabs = root.querySelector('.range-tabs');
    var panel = root.querySelector('[data-tab-panel]');
    if (!tabs || !panel) return;
    var cache = {};
    var initial = panel.getAttribute('data-initial') || 'halloween-sweets';
    cache[initial] = panel.innerHTML;
    var skeleton = '<div class="range-skeleton" aria-hidden="true">' +
      '<div class="range-skeleton__card"></div><div class="range-skeleton__card"></div><div class="range-skeleton__card"></div><div class="range-skeleton__card"></div></div>';

    function wakeImages(node) {
      if (!node) return;
      var images = node.querySelectorAll('img.lazyload');
      var check = function () {
        images.forEach(function (img) {
          if (window.theme && theme.LazyImage && theme.LazyImage.inlineCheck) theme.LazyImage.inlineCheck(img);
        });
        if (window.theme && theme.LazyImage && theme.LazyImage.api && theme.LazyImage.api.update) theme.LazyImage.api.update();
        window.dispatchEvent(new Event('mutation'));
      };
      check();
      window.requestAnimationFrame(check);
    }

    function show(handle, html) {
      panel.innerHTML = html;
      wakeImages(panel);
      if (window.applyInDemandBadges) window.applyInDemandBadges(panel, true);
    }

    function load(button) {
      var handle = button.getAttribute('data-collection');
      if (!handle) return;
      tabs.querySelectorAll('[role="tab"]').forEach(function (tab) {
        var on = tab === button;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (cache[handle]) {
        show(handle, cache[handle]);
        return;
      }
      panel.innerHTML = skeleton;
      fetch(cartBase() + 'collections/' + handle + '?view=halloween-grid', { headers: { Accept: 'text/html' } })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var box = doc.querySelector('.hw-tab-products');
          var cards = box ? box.innerHTML : '';
          cache[handle] = cards;
          show(handle, cards);
        })
        .catch(function () {
          panel.innerHTML = '<p class="range-tabs__error">Couldn’t load that range. Please try again.</p>';
        });
    }

    tabs.addEventListener('click', function (event) {
      var button = event.target.closest('[role="tab"]');
      if (!button || !tabs.contains(button) || button.classList.contains('is-active')) return;
      load(button);
    });
  }

  function lazyVideos(root) {
    var videos = root.querySelectorAll('video');
    if (!videos.length) return;
    var play = function (video) {
      var pending = video.play();
      if (pending && pending.catch) pending.catch(function () {});
    };
    if (!('IntersectionObserver' in window)) {
      videos.forEach(play);
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) play(entry.target);
        else entry.target.pause();
      });
    }, { rootMargin: '300px 0px' });
    videos.forEach(function (video) { observer.observe(video); });
  }

  function scan(scope) {
    (scope || document).querySelectorAll('.hw26').forEach(boot);
  }

  if (!window.__hw26CartWatch) {
    window.__hw26CartWatch = true;
    var refreshBars = function () {
      document.querySelectorAll('.hw26').forEach(function (root) {
        if (root._readCart) root._readCart();
      });
    };
    document.addEventListener('click', function (event) {
      if (event.target.closest('.js-popup-cart-ajax')) window.setTimeout(refreshBars, 900);
      if (event.target.closest('.hw26 .js-product-button-add-to-cart')) window.setTimeout(refreshBars, 700);
    });
    document.addEventListener('theme:cart::added', function () { window.setTimeout(refreshBars, 400); });
    document.addEventListener('theme:cart::removed', function () { window.setTimeout(refreshBars, 900); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();

  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector && event.target.querySelector('.hw26');
    if (root && root._timer) window.clearInterval(root._timer);
  });
})();
